var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container containerapp"},[_c('div',{staticClass:"mainbody"},[_c('NavBarSimple',{staticClass:"navbarapp"}),_c('div',{staticClass:"routerviewapp"},[_vm._t("default")],2)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }